module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/okLeftPest.71cb865.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/okLeftPest.png
// module id = fbI5
// module chunks = 0